type UtmSynapseInstance = typeof import('utm-synapse')['utmSynapse'];

let cachedUtmSynapse: UtmSynapseInstance | null = null;

export const getUtmSynapse = (): UtmSynapseInstance | null => {
  if (typeof window === 'undefined') {
    return null;
  }

  if (!cachedUtmSynapse) {
    // eslint-disable-next-line global-require, @typescript-eslint/no-var-requires
    cachedUtmSynapse = require('utm-synapse').utmSynapse as UtmSynapseInstance;
  }

  return cachedUtmSynapse;
};
